class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $(document).ready(function(){
      if ($(window).width() < 768) { //768px未満の時
        $(function () {
          $(".acc-trigger").on("click", function () {
            $(this).next().slideToggle(300);
            $(this).toggleClass("is-open", 300);
          });
          $(".js-accAnswer").eq(0).css('display', 'block');
        });  
      }
    });

    $(document).ready(function(){
      if ($(window).width() < 768) { //768px未満の時
        $(function () {
          $(".acc-trigger02").on("click", function () {
            $(this).next().slideToggle(300);
            $(this).toggleClass("is-open", 300);
          });
          $(".js-accAnswer02").eq(0).css('display', 'block');
        });  
      }
    });


  }
}